import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { useTranslation } from '../../hooks';
import { DOCUMENTATION_URL } from '../../constants';

const StyledPageHeader = styled(PageHeader)`
  [data-test='page-header-documentation-link'] {
    margin-top: ${pxToRem(30)};
  }
`;

export const testIds = {
  segmentationViewHeader: 'segmentation-view-header',
};

export const SegmentationViewHeader = () => {
  const { t } = useTranslation();
  return (
    <StyledPageHeader
      data-test={testIds.segmentationViewHeader}
      documentation={{ content: t('header.documentation'), href: DOCUMENTATION_URL }}
      variant={PAGE_HEADER_VARIANTS.SECONDARY}
    >
      {t('header.segmentation')}
    </StyledPageHeader>
  );
};
